import React from 'react';
import AttachmentContent from "./attachment-content.jsx";
import DatesContent from "./dates-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";

const UpdateContent = ({element}) => {
    let updateData = element?.diff;

    try {
        if (typeof updateData === "string") {
            updateData = JSON.parse(updateData);
        }

        if (!updateData || typeof updateData !== "object") {
            updateData = {};
        }
    } catch {
        updateData = {};
    }

    const entries = Object.entries(updateData);
    if (!entries.length) return null;

    return (
        <tr className="update-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full">

                    <thead>
                    <tr className='text-left'>
                        <th style={{width: "30%"}}>Campo</th>
                        <th style={{width: "35%"}}>Novo</th>
                        <th style={{width: "35%"}}>Antigo</th>
                    </tr>
                    </thead>

                    <tbody>
                    {entries.map(([key, value], index) => {

                        if (key === "attachment") {
                            const attachments = Array.isArray(value) ? value : Object.values(value);

                            return (
                                <AttachmentContent key={index} attachments={attachments} isUpdate/>
                            );
                        }

                        if (key === "dates") {
                            return (
                                <DatesContent key={index} dates={value} isUpdate/>
                            );
                        }

                        let label = key;
                        if (key.trim() === "attendance_lastuser") {
                            label = "Usuário que realizou alteração";
                        }

                        return (
                            <tr key={index} className="text-left">
                                <td>{label}</td>
                                <td className={'break-all! whitespace-normal'}>{ReportUtils.formatObjectString(value?.new)}</td>
                                <td className={'break-all! whitespace-normal'}>{ReportUtils.formatObjectString(value?.old)}</td>
                            </tr>
                        );
                    })}
                    </tbody>

                </table>
            </td>
        </tr>
    );
};

export default UpdateContent;